import { render, staticRenderFns } from "./CalendarLegend.vue?vue&type=template&id=4f90e4e5"
import script from "./CalendarLegend.vue?vue&type=script&lang=js"
export * from "./CalendarLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports